import {parsePhoneNumber} from 'libphonenumber-js';
import metadata from 'libphonenumber-js/metadata.min.json'

export const parsePhone = (phone) => {
    return parsePhoneNumber(phone, metadata);
}
